import { render, staticRenderFns } from "./BCXChevronSwitch.vue?vue&type=template&id=6a74956c&scoped=true"
import script from "./BCXChevronSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./BCXChevronSwitch.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BCXChevronSwitch.vue?vue&type=style&index=0&id=6a74956c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a74956c",
  null
  
)

export default component.exports